<template>
  <div class="coupon-input">
    <wptv-promotional-code
      ref="promotionalCode"
      :custom-wording="$t('fip.coupons')"
      :dark-mode="true"
      :add-code-cb="clickValidate"
      :cancel-cb="clickDeactivate"
      :show-success="hasValidCoupon" />
  </div>
</template>

<script>
import _get from 'lodash/get'
import { mapGetters } from 'vuex'
import { accessChecks } from '../../../../../middleware/checkups'
import { WptvPromotionalCode } from '@wptv/components/ui/promotionalCode'

export default {
  name: 'CouponInput',
  components: {
    WptvPromotionalCode
  },
  props: {
    discountedDefinition: {
      type: Object,
      required: true
    },
    bannerDefinition: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      hasValidCoupon: false
    }
  },
  computed: {
    ...mapGetters({
      profile: 'core/getProfile',
      activatedCoupon: 'user/getActivatedCoupon'
    }),
    hasCoupon () {
      return this.activatedCoupon && Object.keys(this.activatedCoupon).length > 0
    },
    isCouponApplicable () {
      return !!(_get(this.discountedDefinition, 'discountId') === _get(this.activatedCoupon, 'id') &&
        (_get(this.discountedDefinition, 'name') || _get(this.discountedDefinition, 'description')))
    }
  },
  beforeMount () {
    if (this.hasCoupon && this.isCouponApplicable) {
      this.hasValidCoupon = true
    }
  },
  mounted () {
    // Adjust width of Promotional Code Content component
    this.$refs.promotionalCode.$el.querySelector('.ob1-promotional-code-content').classList.add('w-auto')
  },
  methods: {
    clickValidate (inputCode) {
      return accessChecks(this.$store, this.profile, false, true, false, this.$route)
        .then(() => {
          if (inputCode && inputCode !== '') {
            this.sendStats(this.$stats.fip.onValidateCoupon(inputCode))
            return this.checkCodeValidity(inputCode)
          }
        })
    },
    clickDeactivate () {
      this.sendStats(this.$stats.fip.onDeactivateDiscount(this.activatedCoupon))
      this.$store.commit('user/resetActivatedCoupon', this.activatedCoupon.id)
      return Promise.resolve(true)
    },
    checkCodeValidity (inputCode) {
      return this.$store.dispatch('user/getCouponDiscount', { coupon: inputCode })
        .then(() => this.storeCouponCode(inputCode))
        .then(this.activateCoupon)
        .catch((res) => {
          const errorCode = _get(res, 'error.data.code', res).toString()
          const checkErrorExist = this.$te(`fip.coupons.error.${errorCode}`)

          if (checkErrorExist) {
            return Promise.reject(this.$t(`fip.coupons.error.${errorCode}`))
          } else {
            this.$store.dispatch('errors/setAxiosError', { error: res })
            return Promise.reject()
          }
        })
    },
    storeCouponCode (inputCode) {
      this.$store.commit('user/setCouponCode', inputCode) // /!\ needed in payment request params
      return Promise.resolve()
    },
    /**
     * Activation du discount dans le store (userDiscount) + affichage du bon message
     */
    activateCoupon () {
      if (this.isCouponApplicable) {
        return Promise.resolve()
      } else {
        return Promise.reject(Object.keys(this.bannerDefinition).length > 0 ? 'valide_not_prio' : 'valide_not_applicable')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .coupon-input {
    position: relative;
    width: 100%;
    z-index: 2;
  }
</style>
